import React from "react";
import DropOffCard from "./DropOffCard";

const Result = ({ req, index, data, getDropOff }) => {
  return (
    <div key={index} className="dropOffGroup">
      <div className="dropOffGroup__header">
        {req}
        <span className="dropOffGroup__count">{data.length}</span>
      </div>
      {data.map((datum, index) => (
        <DropOffCard
          key={datum?.id || datum?.code || index}
          dropOff={datum}
          onView={getDropOff}
        />
      ))}
    </div>
  );
};

export default Result;
